import { render } from "./ModalBan.vue?vue&type=template&id=8cdffd18&scoped=true"
import script from "./ModalBan.vue?vue&type=script&lang=js"
export * from "./ModalBan.vue?vue&type=script&lang=js"

import "./ModalBan.vue?vue&type=style&index=0&id=8cdffd18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cdffd18"]])

export default __exports__